<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top app-header">
    <div class="container">
      <div class="button button-back" @click="leftAction">
        <div :class="{'hidden': hideLeft}">
          <i :class="`fa fa-${leftIcon}`" />
        </div>
      </div>
      <h1>
        <small v-if="subtitle">{{subtitle}}</small>
        {{title}}
      </h1>
      <div class="button button-help" @click="rightAction">
        <div :class="{'hidden': hideRight}">
          <i :class="`fa fa-${rightIcon}`" />
          <span class="badge badge-danger badge-numpedidos" v-if="!hideNumber && numPedidos > 0"
          >{{numPedidos}}</span>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import config from '../../config'

export default {
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: config.companyName },
    leftIcon: { type: String, default: 'chevron-left' },
    rightIcon: { type: String, default: 'shopping-cart' },
    leftAction: {
      type: Function,
      default: () => console.log('leftAction clicked ...')
    },
    rightAction: {
      type: Function,
      default: () => console.log('rightAction clicked ...')
    },
    rightNumber: {
      type: Number
    },
    hideLeft: { type: Boolean, default: false },
    hideRight: { type: Boolean, default: false },
    hideNumber: { type: Boolean, default: false }
  },
  computed: {
    numPedidos() {
      if (this.rightNumber) return this.rightNumber
      const profile = this.$store.state.profile
      return profile && profile.order ? Object.keys(profile.order).length : 0
    }
  }
}
</script>
<style lang="scss">
.app-header {
  padding: 8px;

  .container {
    max-width: 600px;
  }

  .hidden {
    visibility: hidden !important;
  }

  .button {
    background-color: hsla(0, 0%, 100%, 0.06);
    border-radius: 0.3rem;
    color: white;
    padding: 0.2em 1em;
    font-size: 1.25rem;
    position: relative;

    .badge-numpedidos {
      position: absolute;
      top: -4px;
      right: 45px;
    }
  }

  h1 {
    color: #fff;
    display: block;
    flex: 1;
    font-size: 1.125rem;
    font-weight: 100;
    text-align: center;
    margin: 0;
    @media screen and (max-width: 340px) {
      font-size: 0.84rem;
    }

    small {
      color: hsla(0, 0%, 100%, 0.42);
      display: block;
      font-size: 0.75rem;
    }
  }
}
</style>